import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./auth";
import { initDatadogRum } from "./lib/datadog";
import { initDatadogLogs } from "./lib/logger";
import "./index.css";

// Start client-side telemetry before anything renders, so early errors are
// captured too. Both no-op unless the Datadog build args were supplied
// (see lib/datadog and lib/logger).
initDatadogRum();
initDatadogLogs();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);
